var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.applicationIsLocked
    ? _c(
        "fixed-banner",
        {
          staticClass: "w-100 app-standalone",
          attrs: {
            id: "locked-application-banner",
            icon: "lock",
            type: "error",
            "position-fixed": _vm.positionFixed,
            "side-right": _vm.sideRight,
          },
        },
        [_vm._v("\n  " + _vm._s(_vm.bannerMessage) + "\n")]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }